export default {
    savedSuccessfully:'Sächsische Ehrenamtskarte erfolgreich beantragt',
}
